import React, { useMemo } from 'react';
import { useStore } from '../state/store';
import { Chip, Card } from '../components/ui';
import { FinishSetup } from '../components/FinishSetup';
import { TodayCommitted } from '../components/TodayCommitted';
import { CommercialPulse } from '../components/CommercialPulse';
import { AttentionNeeded } from '../components/AttentionNeeded';
import { composeBriefing } from '../lib/bridge';
import { describeRunway } from '../lib/derive';
import { deriveGateReadiness } from '../lib/gates';
import { d001Surfacing, deriveOperatingMode } from '../lib/operatingMode';

export default function MobileToday({ go, openModal }) {
  const { state, d } = useStore();
  const { runway } = d;
  const operating = deriveOperatingMode(state, d);
  const isSetup = operating.mode === 'setup';
  const gate15 = deriveGateReadiness(state, d, 15);
  const compact = gate15.compact || {};
  const runwayCopy = describeRunway(runway);
  const runwayTone = { healthy: 'green', watch: 'amber', critical: 'red', unknown: '' }[runway.status];
  const gateTone = compact.status === 'ON TRACK'
    ? 'green'
    : compact.status === 'OFF TRACK'
      ? 'red'
      : compact.status === 'AT RISK'
        ? 'amber'
        : '';
  const briefing = useMemo(
    () => composeBriefing(state, d, { overrides: state.bridgeRecommendations || [] }),
    [state, d],
  );
  const surfacing = d001Surfacing(d);
  const gateLabel = compact.status === 'NOT ASSESSABLE' || !compact.status
    ? 'Not enough information yet'
    : compact.status;
  const constraintTitle = briefing.constraint?.title || 'Not enough information yet to name the constraint';

  if (isSetup) {
    return (
      <div className="mobile-today">
        <FinishSetup go={go} />
        {(state.accounts || []).length > 0 && (
          <section className="section">
            <Card title="While you finish setup">
              <p className="dim tiny">
                Confirm or defer your priority accounts to unlock Today’s full plan.
              </p>
            </Card>
          </section>
        )}
      </div>
    );
  }

  return (
    <div className="mobile-today">
      <div className="mobile-truth">
        <Chip tone={gateTone}>{gateLabel}</Chip>
        <Chip tone={runwayTone}>{runwayCopy.primary}</Chip>
      </div>

      <TodayCommitted go={go} compact />

      <section className="section">
        <div className="eyebrow">Current situation</div>
        <h2 style={{ fontSize: 18, margin: '4px 0 8px' }}>{constraintTitle}</h2>
        {briefing.diagnosis ? <p className="dim tiny">{briefing.diagnosis}</p> : null}
      </section>

      <CommercialPulse go={go} />
      <AttentionNeeded go={go} openModal={openModal} />

      {surfacing.showOnToday && (
        <button type="button" className="btn primary" style={{ width: '100%', marginTop: 8 }} onClick={() => go('primary-deal')}>
          Open Primary D001
        </button>
      )}
    </div>
  );
}
